import productAbi from "@/contracts/abi/holesky/BlazpayProducts.json";
import stakeAbi from "@/contracts/abi/holesky/StakeShardeum.json";
import productGamesAbi from "@/contracts/abi/arbitrum/ProductGames.json";
import productNFTsAbi from "@/contracts/abi/arbitrum/ProductNFTs.json";
import productTokenAbi from "@/contracts/abi/arbitrum/ProductToken.json";
import productStakeAbi from "@/contracts/abi/polygon/productStakeAbi.json";
import gamesDeposit from "@/contracts/abi/arbitrum/GamesDeposit.json";
import marketplaceAbi from "@/contracts/abi/arbitrum-sepolia/MarketplaceNFTv2.json";
import migrationV3Abi from "@/contracts/abi/arbitrum-sepolia/MigrationV3.json";
import bzNftStakingAbi from "@/contracts/abi/arbitrum-sepolia/bz-nft-staking.json";
import pokerAbi from "@/contracts/abi/arbitrum-sepolia/poker.json";
import type { InterfaceAbi } from "ethers";

const bzMarketplaceAbi: InterfaceAbi = [
  {
    inputs: [
      { internalType: "address", name: "collection", type: "address" },
      { internalType: "uint256", name: "tokenId", type: "uint256" },
      { internalType: "uint256", name: "price", type: "uint256" },
    ],
    name: "listNFT",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "collection", type: "address" },
      { internalType: "uint256", name: "tokenId", type: "uint256" },
    ],
    name: "cancelListing",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "collection", type: "address" },
      { internalType: "uint256", name: "tokenId", type: "uint256" },
      { internalType: "uint256", name: "newPrice", type: "uint256" },
    ],
    name: "updateListing",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "collection", type: "address" },
      { internalType: "address", name: "from", type: "address" },
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "tokenId", type: "uint256" },
      { internalType: "uint256", name: "deadline", type: "uint256" },
      { internalType: "uint256", name: "price", type: "uint256" },
      { internalType: "bytes", name: "signature", type: "bytes" },
    ],
    name: "executeHybridTrade",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

export const chains = [
  // // QUBETICS TESTNET
  // {
  //   id: '9029',
  //   name: 'Qubetics Testnet',
  //   nativeCurrency: {
  //     name: 'tics',
  //     symbol: 'tics',
  //     decimals: 18,
  //   },
  //   rpcUrls: ['https://rpc-testnet.qubetics.work'],
  //    blockExplorerUrls: ["https://testnet.qubetics.work"],
  //   tokenImg:
  //     'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRSUWIwe4tBmDnAPd1auPiPmwP7vKwuC5fRrg&s',
  //   features: {
  //     gameValue: 0.005,
  //     mintValue: 0.5,
  //     stakeValue: 0.5,
  //     apiStaking: false,
  //     gasLimit: false,
  //     isMainnet: false,
  //   },
  //   contracts: {
  //     NFT: {
  //       address: '0x60d94ae2a429be78a1099733356Ab88009B049EF',
  //       abi: stakeAbi,
  //     },
  //     Stake: {
  //       address: '0x977a52a98539667FbF5810A889B5780fa1704E2A',
  //       abi: productStakeAbi,
  //     },
  //     Token3: {
  //       address: '0xa75A5bEE03CC551999C193159f68b68768e16d7D',
  //       abi: productTokenAbi,
  //     },
  //     Game: {
  //       address: '0x0768BDD56A00Fe7E18A91033d4b84Ddbb74d0201',
  //       abi: productGamesAbi,
  //     },
  //     Product: {
  //       address: '0x67d91eC3d43FC21CbB3c6fFcc490677D077E8DfC',
  //       abi: productAbi,
  //     },
  //     Deposit: {
  //       address: '0x3802276DD519ae9dAae011829bF9e8b95cd5D0fE',
  //       abi: gamesDeposit,
  //     },
  //     // Marketplace: {
  //     //   address: '0xeB7df73351175e8a251B6a3691e56bEDDA0A6695',
  //     //   abi: marketplaceAbi,
  //     // },
  //   },
  // },

  // // MONAD TESTNET
  // {
  //   id: '10143',
  //   name: 'Monad Testnet',
  //   nativeCurrency: { name: 'MON', symbol: 'MON', decimals: 18 },
  //   rpcUrls: ['https://rpc.ankr.com/monad_testnet'],
  //   blockExplorerUrls: ['https://testnet.monadexplorer.com/'], // Consider changing to blockExplorerUrls: ['...']
  //   tokenImg: 'https://docs.monad.xyz/img/monad_logo.webp',
  //   features: {
  //     gameValue: 0,
  //     mintValue: 0,
  //     stakeValue: 0,
  //     unStakeValue: 0.00003,
  //     apiStaking: false,
  //     gasLimit: false,
  //     isMainnet: false,
  //   },
  //   contracts: {
  //     NFT: {
  //       address: '0x074D1a5ba06218D4a10020c801436231522EC669',
  //       abi: stakeAbi,
  //     },
  //     Stake: {
  //       address: '0xBB7c405bAB67C0191cacCe92a93440fB5A871e2c',
  //       abi: newStakeAbi,
  //     },
  //     Token3: {
  //       address: '0xDF7644B9074aeD5604d7Bc2a9ed6eb3e9C04403E',
  //       abi: productTokenAbi,
  //     },
  //     Game: {
  //       address: '0x183FF5839dA2F74c3e861171Dba4440DBeE7542f',
  //       abi: productGamesAbi,
  //     },
  //     Product: {
  //       address: '0xb4753534Adc5A94C09D6D717855b4FB7d431AaF5',
  //       abi: productNFTsAbi,
  //     },
  //     Deposit: {
  //       address: '0x55fc61c20b506fC79e64c03Fa015257da384cd83',
  //       abi: gamesDeposit,
  //     },
  //   },
  // },

  // AVALANCHE
  {
    id: "43114",
    name: "Avalanche Network C-Chain",
    nativeCurrency: {
      name: "AVAX",
      symbol: "AVAX",
      decimals: 18,
    },
    rpcUrls: ["https://avalanche.drpc.org/"],
    blockExplorerUrls: ["https://snowtrace.io/"],
    tokenImg:
      "https://imagedelivery.net/LQsry4VlRw5rN4KvSzkcLw/471da20d-a526-4ef4-ede6-2768bf6b3500/public",
    features: {
      gameValue: 0.0005,
      mintValue: 0.002,
      stakeValue: 0.002,
      apiStaking: false,
      gasLimit: false,
      isMainnet: true,
    },
    contracts: {
      NFT: {
        address: "0xA01da2d3AbEFFbaa347B08C76EEC47169DdE72e9",
        abi: stakeAbi,
      },
      Stake: {
        address: "0xA78D3c113C1b24Ff11DfE974bFe7c6f67a6Da5c3",
        abi: productStakeAbi,
      },
      Token3: {
        address: "0x4dE7CD522f1715b2a48F3ad6612924841d450A0F",
        abi: productTokenAbi,
      },
      Game: {
        address: "0xdFF5eDBD8A8520A884c26A9d4779661170131a00",
        abi: productGamesAbi,
      },
      Product: {
        address: "0x7ea13d779369e3b0b5F78cB050aD97DE6cA9CfBD",
        abi: productAbi,
      },
      Deposit: {
        address: "0x3802276DD519ae9dAae011829bF9e8b95cd5D0fE",
        abi: gamesDeposit,
      },
      BzNFTStaking: {
        address: "0xA1c187BdF416A56103920c9505DfeDaF8a52fa10",
        abi: bzNftStakingAbi,
      },
      BlazRocketNFT: {
        address: "0x10cA0B3b575F23CDBE66E0502585A4F7E2D8AaB6",
        abi: [],
      },
      MarketplaceNFT: {
        address: "0x2ae446a2fA638144b4Dc8B36113d67E853E75CE0",
        abi: marketplaceAbi,
      },
      BzMarketplace: {
        address: "0x2ae446a2fA638144b4Dc8B36113d67E853E75CE0",
        abi: bzMarketplaceAbi,
      },
      Stake_Old: {
        address: "0xA78D3c113C1b24Ff11DfE974bFe7c6f67a6Da5c3",
        abi: migrationV3Abi,
      }
    },
  },

  // LINEA
  // {
  //   id: "59144",
  //   name: "Linea",
  //   nativeCurrency: {
  //     name: "ETH",
  //     symbol: "ETH",
  //     decimals: 18,
  //   },
  //   rpcUrls: ["https://linea.drpc.org", "https://1rpc.io/linea"],
  //   blockExplorerUrls: ["https://lineascan.build/"], // This was already correct
  //   tokenImg: "https://i.ibb.co/G7yghkS/linea-Logo.webp",
  //   features: {
  //     gameValue: 0.0000036,
  //     mintValue: 0.00041,
  //     stakeValue: 0.00041,
  //     unStakeValue: 0,
  //     epMintValue: 0.00041,
  //     apiStaking: false,
  //     apiMinting: false,
  //     isMainnet: true,
  //     newOnChainQuery: true,
  //   },
  //   contracts: {
  //     EPNFT: {
  //       address: "0x427539B9f81cd890b554e4f3F36eBa6D6d96e61a",
  //       abi: stakeAbi, // Note: Using productNFTsAbi for EPNFT here as per original
  //     },
  //     NFT: {
  //       address: "0x4694598904EC8909FA0f6A2992b2BaB4e43397E5",
  //       abi: productNFTsAbi,
  //     },
  //     Stake: {
  //       address: "0xD39218eD9c8d7E19F7c39B8bbD107521CF84F565",
  //       abi: productStakeAbi,
  //     },
  //     Token3: {
  //       address: "0xACAebb2aEF4c73602D4fF43ed2126beF0C1BF103",
  //       abi: productTokenAbi,
  //     },
  //     Game: {
  //       address: "0x3Fa101D15074d0c7378Db206026107f4665b942C",
  //       abi: productGamesAbi,
  //     },
  //     Product: {
  //       address: "0xedd0dDaEdbc3FBf67aC4ff2ee14Ace669821eac1",
  //       abi: productAbi,
  //     },
  //     Deposit: {
  //       address: "0x7e3B78015f26405d5f2460c9A35F77d64CFA5A32",
  //       abi: gamesDeposit,
  //     },
  //   },
  // },
  // //SONEIUM
  {
    id: "1868",
    name: "Soneium",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: 18,
    },
    rpcUrls: ["https://rpc.soneium.org", "https://soneium.drpc.org"],
    blockExplorerUrls: ["https://soneium.blockscout.com/"], // This was already correct
    tokenImg:
      "https://imagedelivery.net/LQsry4VlRw5rN4KvSzkcLw/a5da17b1-4160-46cb-f4f4-fab8c1ce0200/public",
    features: {
      gameValue: 0.000004,
      mintValue: 0.00029,
      stakeValue: 0.00029,
      unStakeValue: 0,
      epMintValue: 0.00029,
      apiStaking: false,
      apiMinting: false,
      isMainnet: true,
      newOnChainQuery: true,
    },
    contracts: {
      EPNFT: {
        address: "0x60d94ae2a429be78a1099733356Ab88009B049EF",
        abi: stakeAbi, // Note: Using productNFTsAbi for EPNFT here as per original
      },
      NFT: {
        address: "0x60d94ae2a429be78a1099733356Ab88009B049EF",
        abi: productNFTsAbi,
      },
      Stake: {
        address: "0x55fc61c20b506fC79e64c03Fa015257da384cd83",
        abi: productStakeAbi,
      },
      Token3: {
        address: "0x67d91eC3d43FC21CbB3c6fFcc490677D077E8DfC",
        abi: productTokenAbi,
      },
      Game: {
        address: "0xF3Acc2dcE7DEBa313DB04f5e5032D2cA377886a0",
        abi: productGamesAbi,
      },
      Product: {
        address: "0x0768BDD56A00Fe7E18A91033d4b84Ddbb74d0201",
        abi: productAbi,
      },
      Deposit: {
        address: "0x7e3B78015f26405d5f2460c9A35F77d64CFA5A32",
        abi: gamesDeposit,
      },
      // Migration (Old Staking) - Used by use-migration.ts
      Stake_Old: {
        address: "0x55fc61c20b506fC79e64c03Fa015257da384cd83",
        abi: migrationV3Abi,
      },
      // BzNFTStaking - Rocket Upgrades & Claims (from Integration Guide)
      BzNFTStaking: {
        address: "0x930ca7684247523A1Ed23A2fD98cB0dF85730e23",
        abi: bzNftStakingAbi,
      },
      // BlazRocketNFT Collection (from Integration Guide)
      BlazRocketNFT: {
        address: "0x8001a63FAbc3D58800633fa584F267B9D6b5dEe5",
        abi: [], // Standard ERC721, no special ABI needed for address lookup
      },
      // NFT Marketplace contracts
      MarketplaceNFT: {
        address: "0x1AcC65Bdf1197039825f01313e9919c55396f604",
        abi: marketplaceAbi,
      },
      BzMarketplace: {
        address: "0x1AcC65Bdf1197039825f01313e9919c55396f604",
        abi: bzMarketplaceAbi,
      },
    },
  },

  // HEMI
  {
    id: "43111",
    name: "Hemi",
    nativeCurrency: {
      name: "ETH",
      symbol: "ETH",
      decimals: 18,
    },
    rpcUrls: ["https://hemi.drpc.org", "https://rpc.hemi.network/rpc"],
    blockExplorerUrls: ["https://explorer.hemi.xyz/"], // This was already correct
    tokenImg:
      "https://imagedelivery.net/LQsry4VlRw5rN4KvSzkcLw/61ce33d7-fb64-408b-640b-fb8629fab100/public",
    features: {
      gameValue: 0.000004,
      mintValue: 0.00029,
      stakeValue: 0.00029,
      unStakeValue: 0,
      epMintValue: 0.00029,
      apiStaking: false,
      apiMinting: false,
      isMainnet: true,
      newOnChainQuery: true,
    },
    contracts: {
      EPNFT: {
        address: "0x4dE7CD522f1715b2a48F3ad6612924841d450A0F",
        abi: stakeAbi, // Note: Using productNFTsAbi for EPNFT here as per original
      },
      NFT: {
        address: "0x4dE7CD522f1715b2a48F3ad6612924841d450A0F",
        abi: productNFTsAbi,
      },
      Stake: {
        address: "0x3BF4154d8b41664a1891C0b50a9e15b9e520d3F4",
        abi: productStakeAbi,
      },
      Token3: {
        address: "0x0768BDD56A00Fe7E18A91033d4b84Ddbb74d0201",
        abi: productTokenAbi,
      },
      Game: {
        address: "0x977a52a98539667FbF5810A889B5780fa1704E2A",
        abi: productGamesAbi,
      },
      Product: {
        address: "0xF3Acc2dcE7DEBa313DB04f5e5032D2cA377886a0",
        abi: productAbi,
      },
      Deposit: {
        address: "0x7e3B78015f26405d5f2460c9A35F77d64CFA5A32",
        abi: gamesDeposit,
      },

      // Migration (Old Staking) - Used by use-migration.ts
      Stake_Old: {
        address: "0x3BF4154d8b41664a1891C0b50a9e15b9e520d3F4",
        abi: migrationV3Abi,
      },
      // BzNFTStaking - Rocket Upgrades & Claims (from Integration Guide)
      BzNFTStaking: {
        address: "0xC86e2e0834fc62b6b1ab4cceFd02387f9F70DCea",
        abi: bzNftStakingAbi,
      },
      // BlazRocketNFT Collection (from Integration Guide)
      BlazRocketNFT: {
        address: "0x1AcC65Bdf1197039825f01313e9919c55396f604",
        abi: [], // Standard ERC721, no special ABI needed for address lookup
      },
      // NFT Marketplace contracts
      MarketplaceNFT: {
        address: "0x6b1E7E2504299883Fd98067CFf1f282c492C4Ee3",
        abi: marketplaceAbi,
      },
      BzMarketplace: {
        address: "0x6b1E7E2504299883Fd98067CFf1f282c492C4Ee3",
        abi: bzMarketplaceAbi,
      },
    },
  },

  // // QUBETICS MAINNET
  {
    id: "9030",
    name: "Qubetics Mainnet",
    nativeCurrency: {
      name: "TICS",
      symbol: "TICS",
      decimals: 18,
    },
    rpcUrls: ["https://evm-rpc-arch.qubetics.com/"],
    blockExplorerUrls: ["https://ticsscan.com/"], // This was already correct
    tokenImg:
      "https://imagedelivery.net/LQsry4VlRw5rN4KvSzkcLw/8376e5d0-4435-4754-7e00-de3c45948700/public",
    features: {
      gameValue: 0.23,
      mintValue: 23,
      stakeValue: 23,
      unStakeValue: 0,
      epMintValue: 0.00041,
      apiStaking: false,
      apiMinting: false,
      isMainnet: true,
      newOnChainQuery: true,
    },
    contracts: {
      EPNFT: {
        address: "0x0a081EEE1f079F4cc30184696AbdCF24F81f01dc",
        abi: stakeAbi, // Note: Using productNFTsAbi for EPNFT here as per original
      },
      NFT: {
        address: "0x0a081EEE1f079F4cc30184696AbdCF24F81f01dc",
        abi: productNFTsAbi,
      },
      Stake: {
        address: "0xF25C7A35bD4b1e306521a4BF521dEf3F360647e3",
        abi: productStakeAbi,
      },
      Token3: {
        address: "0xd7844B233bC879B6a130385bEA3940dC2c0450D8",
        abi: productTokenAbi,
      },
      Game: {
        address: "0x6b32b085a3a97C6186B871De989490780C8feBC2",
        abi: productGamesAbi,
      },
      Product: {
        address: "0x7CaeD5374C436422172865d2b650B6BB96633F27",
        abi: productAbi,
      },
      Deposit: {
        address: "0x7e3B78015f26405d5f2460c9A35F77d64CFA5A32",
        abi: gamesDeposit,
      },
      // Migration (Old Staking) - Used by use-migration.ts
      Stake_Old: {
        address: "0xF25C7A35bD4b1e306521a4BF521dEf3F360647e3",
        abi: migrationV3Abi,
      },
      // BzNFTStaking - Rocket Upgrades & Claims (from Integration Guide)
      BzNFTStaking: {
        address: "0xC3e625a994EE530A8E291A9dD0aF53F368854c06",
        abi: bzNftStakingAbi,
      },
      // BlazRocketNFT Collection (from Integration Guide)
      BlazRocketNFT: {
        address: "0x0C70860B87a612B8F25Eeabd40cD703a0A67df39",
        abi: [], // Standard ERC721, no special ABI needed for address lookup
      },
      // NFT Marketplace contracts
      MarketplaceNFT: {
        address: "0x5bB9e7A0F5F61Bba1eb1582483ba629395928B69",
        abi: marketplaceAbi,
      },
      BzMarketplace: {
        address: "0x5bB9e7A0F5F61Bba1eb1582483ba629395928B69",
        abi: bzMarketplaceAbi,
      },
      PokerManager: {
        address: "0x369c430Bd4E34011F888e72f392d815EA407464b",
        abi: pokerAbi as InterfaceAbi,
      },
    },
  },

  // // HEKLA
  // {
  //   id: '167009',
  //   name: 'Taiko Hekla L2',
  //   nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
  //   rpcUrls: ['https://rpc.hekla.taiko.xyz'],
  //   tokenImg: 'https://i.ibb.co/y5D8dJv/taiko.webp',
  //   blockExplorerUrls: ['https://explorer.hekla.taiko.xyz/'], // Consider changing to blockExplorerUrls: ['...']
  //   features: {
  //     gameValue: 0,
  //     mintValue: 0,
  //     epMintValue: 0.0004,
  //     stakeValue: 0,
  //     apiStaking: false,
  //     gasLimit: false,
  //     isMainnet: false,
  //   },
  //   contracts: {
  //     NFT: {
  //       address: '0xdaEeF7cAB7fa7523da6f7481c850cb27406aE49A',
  //       abi: stakeAbi,
  //     },
  //     Stake_Old1: {
  //       address: '0xD60dBbdFe2095Fd286998BEAcc0B3ce0D4fFFee3',
  //       abi: stakeAbi,
  //     },
  //     Stake_Old2: {
  //       address: '0xdaEeF7cAB7fa7523da6f7481c850cb27406aE49A',
  //       abi: stakeAbi,
  //     },
  //     Stake: {
  //       address: '0x977a52a98539667FbF5810A889B5780fa1704E2A',
  //       abi: productStakeAbi,
  //     },
  //     Token1: {
  //       address: '0xB825e3D37691A59C4BDfD9C8549a79bc8d3A3B8b',
  //       abi: tokenAbi,
  //     },
  //     Token2: {
  //       address: '0x979eBadf1a013d1b6BDAfDE7280B6398b7010C65',
  //       abi: tokenAbi,
  //     },
  //     Token3: {
  //       address: '0xa75A5bEE03CC551999C193159f68b68768e16d7D',
  //       abi: productTokenAbi,
  //     },
  //     Game: {
  //       address: '0x0768BDD56A00Fe7E18A91033d4b84Ddbb74d0201',
  //       abi: productGamesAbi,
  //     },
  //     Product: {
  //       address: '0x20e66A615498176996e654fDA8391cd0D4a86e3b',
  //       abi: productAbi,
  //     },
  //     Product1: {
  //       address: '0x67d91eC3d43FC21CbB3c6fFcc490677D077E8DfC',
  //       abi: productAbi,
  //     },
  //     Deposit: {
  //       address: '0x7D167f7858454672021f0C2869a4AB54D219a997',
  //       abi: gamesDeposit,
  //     },
  //   },
  // },
  // // // HOLESKY
  // {
  //   id: '17000',
  //   name: 'Holesky',
  //   nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
  //   rpcUrls: ['https://ethereum-holesky-rpc.publicnode.com'],
  //   blockExplorerUrls: ['https://holesky.etherscan.io/'], // Consider changing to blockExplorerUrls: ['...']
  //   tokenImg: 'https://i.ibb.co/tHbx9Jw/arbitrum.webp', // Note: using Arbitrum image for Holesky
  //   features: {
  //     gameValue: 0,
  //     mintValue: 0,
  //     stakeValue: 0,
  //     unStakeValue: 0,
  //     apiStaking: false,
  //     gasLimit: false,
  //     onChainQuery: true,
  //     isMainnet: false,
  //   },
  //   contracts: {
  //     NFT: {
  //       address: '0x074D1a5ba06218D4a10020c801436231522EC669',
  //       abi: stakeAbi,
  //     },
  //     Stake_Old1: {
  //       address: '0xd3592602FC5A8f4632f4b130618E09F7ed8e0705',
  //       abi: stakeAbi,
  //     },
  //     Stake_Old2: {
  //       address: '0x074D1a5ba06218D4a10020c801436231522EC669',
  //       abi: stakeAbi,
  //     },
  //     Stake: {
  //       address: '0x0EB9e382488e19d901856F130010D46074b5C064',
  //       abi: productStakeAbi,
  //     },
  //     Token1: {
  //       address: '0x23Bd58929Efbe6469C188459D288437737191328',
  //       abi: tokenAbi,
  //     },
  //     Token2: {
  //       address: '0xe914D607A64c5ac3b2c9db3e1b5D809ec4C2E4BF',
  //       abi: tokenAbi,
  //     },
  //     Token3: {
  //       address: '0x6A7bAb58c360cf465Ad3191f4B5F2896917B4d11',
  //       abi: productTokenAbi,
  //     },
  //     Game: {
  //       address: '0x38f4d439a65b587d780b4fd437EF89c6D9D83f6f',
  //       abi: productGamesAbi,
  //     },
  //     Product: {
  //       address: '0x0096Da996A60b730286d19963539aeE61Bc024B0',
  //       abi: productAbi,
  //     },
  //     Deposit: {
  //       address: '0xb21248396B20E65d907843966f8795577f7f27CA',
  //       abi: gamesDeposit,
  //     },
  //   },
  // },
  // // MONAD
  // {
  //   id: '10143',
  //   name: 'Monad Testnet',
  //   nativeCurrency: { name: 'MON', symbol: 'MON', decimals: 18 },
  //   rpcUrls: [
  //     'https://testnet-rpc2.monad.xyz/52227f026fa8fac9e2014c58fbf5643369b3bfc6',
  //   ],
  //   blockExplorerUrls: ['https://testnet.monadexplorer.com/'], // Consider changing to blockExplorerUrls: ['...']
  //   tokenImg: 'https://docs.monad.xyz/img/monad_logo.webp',
  //   features: {
  //     gameValue: 0,
  //     mintValue: 0.00003,
  //     stakeValue: 0.00003,
  //     unStakeValue: 0.00003,
  //     apiStaking: false,
  //     gasLimit: false,
  //     isMainnet: false,
  //   },
  //   contracts: {
  //     NFT: {
  //       address: '0x074D1a5ba06218D4a10020c801436231522EC669',
  //       abi: stakeAbi,
  //     },
  //     Stake: {
  //       address: '0xf38c90BbECeE227a7Ae153B1fA4c7216292C8b61',
  //       abi: newStakeAbi,
  //     },
  //     Token3: {
  //       address: '0x38A3321A419B8688f539a600e3C7898a0528737f',
  //       abi: productTokenAbi,
  //     },
  //     Game: {
  //       address: '0xaaDeCC979AC53FCa7Ee6b8f2A94A85F8F7f23729',
  //       abi: productGamesAbi,
  //     },
  //     Product: {
  //       address: '0x07eeceF54B0A8F22B3f388997fD3a2C7e056dC7b',
  //       abi: productNFTsAbi,
  //     },
  //     Deposit: {
  //       address: '0x55fc61c20b506fC79e64c03Fa015257da384cd83',
  //       abi: gamesDeposit,
  //     },
  //   },
  // },
  // {
  //   id: '30732',
  //   name: 'Movement EVM Testnet',
  //   nativeCurrency: { name: 'MOVE', symbol: 'MOVE', decimals: 18 },
  //   rpcUrls: ['https://mevm.devnet.imola.movementlabs.xyz'],
  //   blockExplorerUrls: ['https://explorer.movementlabs.xyz'],
  //   tokenImg: 'https://i.ibb.co/ZXGvbMx/movement-Logo.jpg',
  //   features: {
  //     spinValue: 0,
  //     mintValue: 0,
  //     stakeValue: 0,
  //     unStakeValue: 0,
  //     apiStaking: false,
  //     gasLimit: false,
  //   },
  //   contracts: {
  //     // Entrypass: new ethers.Contract(''),
  //     NFT: new ethers.Contract(
  //       '0x27ddF355f35a772602e71E6C72f0a78132de627E',
  //       stakeAbi
  //     ),
  //     STAKE_OLD: new ethers.Contract(
  //       '0x27ddF355f35a772602e71E6C72f0a78132de627E',
  //       stakeAbi
  //     ),
  //     Stake: new ethers.Contract(
  //       '0x27ddF355f35a772602e71E6C72f0a78132de627E',
  //       stakeAbi
  //     ),
  //     Token1: new ethers.Contract(
  //       '0x31B1a5CE8A84f06b0b5C04eE01a04732aE804b0A',
  //       tokenAbi
  //     ),
  //     Token2: new ethers.Contract(
  //       '0x31B1a5CE8A84f06b0b5C04eE01a04732aE804b0A',
  //       tokenAbi
  //     ),
  //     Game: new ethers.Contract(
  //       '0xb7C401D897C778D33d92Be878Af013A24CA9D8Ed',
  //       gameAbi
  //     ),
  //     Product: new ethers.Contract(
  //       '0x44cb090877c2811ef75dBb50cb779a11ce6cFD31',
  //       productAbi
  //     ),
  //     //Store: new ethers.Contract(''),
  //   },
  // },
  // // POLYGON
  // {
  //   id: '137',
  //   name: 'Polygon Mainnet',
  //   rpcUrls: ['https://polygon-rpc.com/'],
  //   // chainHex: '0x89', // Typically not needed if id is numeric
  //   // currency: 'MATIC', // Covered by nativeCurrency
  //   blockExplorerUrls: ['https://polygonscan.com/'], // Consider changing to blockExplorerUrls: ['...']
  //   tokenImg: 'https://i.ibb.co/MDKTCF6/polygon.webp',
  //   nativeCurrency: {
  //     name: 'MATIC',
  //     symbol: 'MATIC',
  //     decimals: 18,
  //   },
  //   features: {
  //     gameValue: 0.03,
  //     mintValue: 0.5,
  //     stakeValue: 0.5,
  //     epMintValue: 1,
  //     apiStaking: false,
  //     gasLimit: false,
  //     isMainnet: true,
  //   },
  //   contracts: {
  //     EPNFT: {
  //       address: '0x73719028d10654d4CCe4F8345C84d1909c874B7b',
  //       abi: stakeAbi,
  //     },
  //     NFT: {
  //       address: '0xc45F3DEbBecB8156fC8ac564343EA0eDF55B9E81',
  //       abi: stakeAbi,
  //     },
  //     STAKE1: {
  //       address: '0x74638B17aF67e7A5EEaC0529EFa30b77572594Ae',
  //       abi: stakeAbi,
  //     },
  //     STAKE2: {
  //       address: '0xc45F3DEbBecB8156fC8ac564343EA0eDF55B9E81',
  //       abi: stakeAbi,
  //     },
  //     Stake: {
  //       address: '0x2FBB643a241c87CeCf0a20c4f20650fCbD5941F1',
  //       abi: productStakeAbi,
  //     },
  //     Token1: {
  //       address: '0x9a03A57265081ACB87a9EE66CC1D5C4F793C99D2',
  //       abi: tokenAbi,
  //     },
  //     Token2: {
  //       address: '0x79E88A7a861395E33325796E58dEe1642f486d57',
  //       abi: tokenAbi,
  //     },
  //     Token3: {
  //       address: '0xbe080A24C8DC66327e8473878edCae3EC10e130f',
  //       abi: productTokenAbi,
  //     },
  //     Game: {
  //       address: '0x45e1F4e850822c0Bc8c244e5cDd49c5De14Bb3E0',
  //       abi: productGamesAbi,
  //     },
  //     Product: {
  //       address: '0x074D1a5ba06218D4a10020c801436231522EC669',
  //       abi: productAbi,
  //     },
  //     Deposit: {
  //       address: '0xbF69a8c99e1e950332e5396d2289F6D5310A10B8',
  //       abi: gamesDeposit,
  //     },
  //   },
  // },
  // // BSC
  // {
  //   id: '56',
  //   name: 'BNB Smart Chain Mainnet',
  //   nativeCurrency: {
  //     name: 'BNB',
  //     symbol: 'BNB',
  //     decimals: 18,
  //   },
  //   rpcUrls: ['https://bsc-dataseed1.binance.org/'],
  //   blockExplorerUrls: ['https://bscscan.com/'], // Kept as array as per original, blockExplorerUrls is preferred
  //   tokenImg: 'https://i.ibb.co/VMVS2Hc/binance.webp',
  //   features: {
  //     gameValue: 0.000018,
  //     mintValue: 0.002,
  //     stakeValue: 0.002,
  //     epMintValue: 0.0036,
  //     apiStaking: false,
  //     gasLimit: false,
  //     isMainnet: true,
  //   },
  //   contracts: {
  //     EPNFT: {
  //       address: '0x6D6B83c04D3b0842a432f6EEf5C66599bFa52cDC',
  //       abi: stakeAbi,
  //     },
  //     NFT: {
  //       address: '0x0E1230ffBF651651144231E39EBBe26C238B5d16',
  //       abi: stakeAbi,
  //     },
  //     STAKE_OLD: {
  //       address: '0x10CFd016888788077b071A334a47B171AbcF6252',
  //       abi: stakeAbi,
  //     },
  //     Stake: {
  //       address: '0x0274f6f77C7EBCB1EbA702aE11a7a04BD8fA242A',
  //       abi: productStakeAbi,
  //     },
  //     Token1: {
  //       address: '0xA5d3f2a7dD90669843009617C15656D14327EB8d',
  //       abi: tokenAbi,
  //     },
  //     Token2: {
  //       address: '0x075a66C62a96E1f81fe73D9f362599F0bE74bdcD',
  //       abi: tokenAbi,
  //     },
  //     Token3: {
  //       address: '0x63424C5fc96DEDF00630d8ECF1c5982121Ec4e91',
  //       abi: productTokenAbi,
  //     },
  //     Game: {
  //       address: '0xCE115148c65e8488288A5b44e2Fc3b7d37777e48',
  //       abi: productGamesAbi,
  //     },
  //     Product: {
  //       address: '0x1ebbA67f4c78cFa8b58381f3D2474DaB3b133D77',
  //       abi: productAbi,
  //     },
  //     Deposit: {
  //       address: '0x3802276DD519ae9dAae011829bF9e8b95cd5D0fE',
  //       abi: gamesDeposit,
  //     },
  //   },
  // },
  // // MANTA
  // {
  //   id: '169',
  //   name: 'Manta Pacific Mainnet',
  //   nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
  //   rpcUrls: ['https://pacific-rpc.manta.network/http'],
  //   blockExplorerUrls: ['https://pacific-explorer.manta.network/'], // Consider changing to blockExplorerUrls: ['...']
  //   tokenImg: 'https://i.ibb.co/CPzhyTf/manta.webp',
  //   features: {
  //     gameValue: 0.0000036,
  //     mintValue: 0.00007,
  //     stakeValue: 0,
  //     epMintValue: 0.0004,
  //     apiStaking: false,
  //     gasLimit: false,
  //     isMainnet: true,
  //   },
  //   contracts: {
  //     EPNFT: {
  //       address: '0x427539B9f81cd890b554e4f3F36eBa6D6d96e61a',
  //       abi: stakeAbi,
  //     },
  //     NFT: {
  //       address: '0xdaEeF7cAB7fa7523da6f7481c850cb27406aE49A',
  //       abi: stakeAbi,
  //     },
  //     STAKE_OLD: {
  //       address: '0xb951A0a8afa9Fa5B729Ad3ade861a610bCb62Df6',
  //       abi: stakeAbi,
  //     },
  //     Stake: {
  //       address: '0xBB7c405bAB67C0191cacCe92a93440fB5A871e2c',
  //       abi: productStakeAbi,
  //     },
  //     Token1: {
  //       address: '0x3FD63640BbC970945C909338eE38371a4d8c13D6',
  //       abi: tokenAbi,
  //     },
  //     Token2: {
  //       address: '0x979eBadf1a013d1b6BDAfDE7280B6398b7010C65',
  //       abi: tokenAbi,
  //     },
  //     Token3: {
  //       address: '0x3C2Fd7C031EA322d99D063Df50f6367892244668',
  //       abi: productTokenAbi,
  //     },
  //     Game: {
  //       address: '0x183FF5839dA2F74c3e861171Dba4440DBeE7542f',
  //       abi: productGamesAbi,
  //     },
  //     Product: {
  //       address: '0xEEb788E8A677E8A9Ffc25040eb3810669110E55C',
  //       abi: productAbi,
  //     },
  //     Deposit: {
  //       address: '0x7F4af39C4f3AaF044854cEd0858412e3e8E65874',
  //       abi: gamesDeposit,
  //     },
  //   },
  // },
  // // LINEA
  // {
  //   id: '59144',
  //   name: 'Linea',
  //   nativeCurrency: {
  //     name: 'ETH',
  //     symbol: 'ETH',
  //     decimals: 18,
  //   },
  //   rpcUrls: ['https://1rpc.io/linea'],
  //   blockExplorerUrls: ['https://lineascan.build/'], // This was already correct
  //   tokenImg: 'https://i.ibb.co/G7yghkS/linea-Logo.webp',
  //   features: {
  //     gameValue: 0.0000036,
  //     mintValue: 0.00041,
  //     stakeValue: 0.00041,
  //     unStakeValue: 0,
  //     epMintValue: 0.00041,
  //     apiStaking: false,
  //     apiMinting: false,
  //     isMainnet: true,
  //     newOnChainQuery: true,
  //   },
  //   contracts: {
  //     EPNFT: {
  //       address: '0x427539B9f81cd890b554e4f3F36eBa6D6d96e61a',
  //       abi: stakeAbi, // Note: Using productNFTsAbi for EPNFT here as per original
  //     },
  //     NFT: {
  //       address: '0x4694598904EC8909FA0f6A2992b2BaB4e43397E5',
  //       abi: productNFTsAbi,
  //     },
  //     Stake: {
  //       address: '0x977a52a98539667FbF5810A889B5780fa1704E2A',
  //       abi: productStakeAbi,
  //     },
  //     Token3: {
  //       address: '0xa75A5bEE03CC551999C193159f68b68768e16d7D',
  //       abi: productTokenAbi,
  //     },
  //     Game: {
  //       address: '0x0768BDD56A00Fe7E18A91033d4b84Ddbb74d0201',
  //       abi: productGamesAbi,
  //     },
  //     Product: {
  //       address: '0x67d91eC3d43FC21CbB3c6fFcc490677D077E8DfC',
  //       abi: productAbi,
  //     },
  //     Deposit: {
  //       address: '0x7e3B78015f26405d5f2460c9A35F77d64CFA5A32',
  //       abi: gamesDeposit,
  //     },
  //   },
  // },
  // // ARBITRUM
  // {
  //   id: '42161',
  //   name: 'Arbitrum One',
  //   nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
  //   rpcUrls: [
  //     'https://endpoints.omniatech.io/v1/arbitrum/one/public',
  //     'https://arbitrum.llamarpc.com',
  //   ],
  //   blockExplorerUrls: 'https://arbiscan.io/', // Consider changing to blockExplorerUrls: ['...']
  //   tokenImg: 'https://i.ibb.co/tHbx9Jw/arbitrum.webp',
  //   features: {
  //     gameValue: 0.000004,
  //     mintValue: 0.00003,
  //     stakeValue: 0.00003,
  //     unStakeValue: 0.00003,
  //     epMintValue: 0.0005,
  //     apiStaking: false,
  //     gasLimit: false,
  //     isMainnet: true,
  //   },
  //   contracts: {
  //     EPNFT: {
  //       address: '0xC88a361952f0d19f70eC2691298F44bfb42a3F5c',
  //       abi: stakeAbi,
  //     },
  //     NFT: {
  //       address: '0x074D1a5ba06218D4a10020c801436231522EC669',
  //       abi: stakeAbi,
  //     },
  //     Stake: {
  //       address: '0x10cA0B3b575F23CDBE66E0502585A4F7E2D8AaB6',
  //       abi: productStakeAbi,
  //     },
  //     Token3: {
  //       address: '0xA3E882aC208d729ad63A0064af33b06B1E7EDF02',
  //       abi: productTokenAbi,
  //     },
  //     Game: {
  //       address: '0x015289DB92E1A5A31a6A21c88F4127846be38C37',
  //       abi: productGamesAbi,
  //     },
  //     Product: {
  //       address: '0x8001a63FAbc3D58800633fa584F267B9D6b5dEe5',
  //       abi: productNFTsAbi,
  //     },
  //     Deposit: {
  //       address: '0x80178a54B7Ce9B9Fabb8fb6b2f2F4E76842257e5',
  //       abi: gamesDeposit,
  //     },
  //   },
  // },
  // TAIKO
  // {
  //   id: '167000',
  //   name: 'Taiko', // Mainnet
  //   nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
  //   rpcUrls: ['https://rpc.ankr.com/taiko'],
  //   blockExplorerUrls: ['https://taikoscan.io'], // This was already correct
  //   tokenImg: 'https://i.ibb.co/y5D8dJv/taiko.webp',
  //   features: {
  //     spinValue: 0, // Note: spinValue, not gameValue here
  //     mintValue: 0.0004,
  //     stakeValue: 0,
  //     unStakeValue: 0,
  //     epMintValue: 0.0004,
  //     apiStaking: false,
  //     apiMinting: false,
  //     gasLimit: false,
  //     isMainnet: true,
  //   },
  //   contracts: {
  //     EPNFT: {
  //       address: '0x60d078234bCDd1c86C5020D4a64A2213568765a4',
  //       abi: stakeAbi,
  //     },
  //   },
  // },
  // BITLAYER
  // {
  //   id: '200901',
  //   name: 'Bitlayer Mainnet',
  //   nativeCurrency: { name: 'BTC', symbol: 'BTC', decimals: 18 },
  //   rpcUrls: ['https://rpc.bitlayer.org/'],
  //   blockExplorerUrls: 'https://www.btrscan.com/',
  //   tokenImg: 'https://storage.googleapis.com/squidlor/photos/BitlayerLogo.webp',
  //   features: {
  //     gameValue: 0.00003,
  //     mintValue: 0.00003,
  //     stakeValue: 0.00003,
  //     unStakeValue: 0.00003,
  //     apiStaking: false,
  //     gasLimit: false,
  //   },
  //   contracts: {
  //     EPNFT: {
  //       address: '0x60d94ae2a429be78a1099733356Ab88009B049EF',
  //       abi: stakeAbi,
  //     },
  //     NFT: {
  //       address: '0x60d94ae2a429be78a1099733356Ab88009B049EF',
  //       abi: stakeAbi,
  //     },
  //     Stake: {
  //       address: '0x10cA0B3b575F23CDBE66E0502585A4F7E2D8AaB6',
  //       abi: productStakeAbi,
  //     },
  //     Token3: {
  //       address: '0xA3E882aC208d729ad63A0064af33b06B1E7EDF02',
  //       abi: productTokenAbi,
  //     },
  //     Game: {
  //       address: '0x015289DB92E1A5A31a6A21c88F4127846be38C37',
  //       abi: productGamesAbi,
  //     },
  //     Product: {
  //       address: '0x8001a63FAbc3D58800633fa584F267B9D6b5dEe5',
  //       abi: productNFTsAbi,
  //     },
  //     Deposit: {
  //       address: '0x80178a54B7Ce9B9Fabb8fb6b2f2F4E76842257e5',
  //       abi: gamesDeposit,
  //     },
  //   },
  // },
  // {
  //   id: "997",
  //   name: "5ireChain Thunder",
  //   nativeCurrency: {
  //     name: "5ire",
  //     symbol: "5ire",
  //     decimals: 18,
  //   },
  //   rpcUrls: ["https://rpc.ga.5ire.network/"],
  //   blockExplorerUrls: ["https://explorer.ga.5ire.network/"],
  //   tokenImg: "https://i.ibb.co/VMVS2Hc/binance.webp",
  //   features: {
  //     spinValue: 0,
  //     mintValue: 0,
  //     stakeValue: 0,
  //     apiStaking: false,
  //     gasLimit: false,
  //   },
  //   contracts: {
  //     NFT: new ethers.Contract(
  //       "0xdaEeF7cAB7fa7523da6f7481c850cb27406aE49A",
  //       stakeAbi
  //     ),
  //     Stake: new ethers.Contract(
  //       "0xdaEeF7cAB7fa7523da6f7481c850cb27406aE49A",
  //       stakeAbi
  //     ),
  //     Token2: new ethers.Contract(
  //       "0x979eBadf1a013d1b6BDAfDE7280B6398b7010C65",
  //       tokenAbi
  //     ),
  //     Game: new ethers.Contract(
  //       "0x0385B8f207D9e258373210deF12F3189f40897e7",
  //       gameAbi
  //     ),
  //     Product: new ethers.Contract(
  //       "0xEEb788E8A677E8A9Ffc25040eb3810669110E55C",
  //       productAbi
  //     ),
  //   },
  // },
  // {
  //   id: "42766",
  //   name: "ZKFair Mainnet",
  //   nativeCurrency: { name: "USDC", symbol: "USDC", decimals: 18 },
  //   rpcUrls: ["https://rpc.zkfair.io"],
  //   blockExplorerUrls: "https://scan.zkfair.io/",
  //   tokenImg: "https://i.ibb.co/y5D8dJv/taiko.webp",
  //   features: {
  //     spinValue: 0.1,
  //     mintValue: 1.5,
  //     stakeValue: 1.5,
  //     unStakeValue: 1.5,
  //     apiStaking: false,
  //   },
  //   contracts: {
  //     // Entrypass: new ethers.Contract(''),
  //     NFT: new ethers.Contract(
  //       "0x8A2E7143f1b153f454836c2fef5d53Fe6d8bB02B",
  //       zkfairStakeAbi
  //     ),
  //     Stake: new ethers.Contract(
  //       "0x8A2E7143f1b153f454836c2fef5d53Fe6d8bB02B",
  //       zkfairStakeAbi
  //     ),
  //     Token: new ethers.Contract(
  //       "0x8bD6f3bD448FcaD043c7b08FafEb3AB04126d9d4",
  //       tokenAbi
  //     ),
  //     Game: new ethers.Contract(
  //       "0xfcc11fCfbAeD8135C13AA2f7129712787b0618d6",
  //       mantaGameAbi
  //     ),
  //     Product: new ethers.Contract(
  //       "0x85523d5EdA897884432Eec14A71B153FbA6832D1",
  //       katlaProductAbi
  //     ),
  //     //Store: new ethers.Contract(''),
  //   },
  // },
  // {
  //   id: '8082',
  //   name: '	Shardeum Sphinx 1.X',
  //   nativeCurrency: {
  //     name: 'SHM',
  //     symbol: 'SHM',
  //     decimals: 18,
  //   },
  //   rpcUrls: ['https://sphinx.shardeum.org/'],
  //   blockExplorerUrls: ['https://explorer-sphinx.shardeum.org/'],
  //   tokenImg: 'https://i.ibb.co/y5D8dJv/taiko.webp',
  //   features: {
  //     spinValue: 0,
  //     mintValue: 0,
  //     stakeValue: 0,
  //     apiStaking: false,
  //     gasLimit:true,
  //   },
  //   contracts: {
  //     // Entrypass: new ethers.Contract(''),
  //     NFT: new ethers.Contract(
  //       '0x97E3aB56ec2C13ACA2993076523F5b3D10D4A138',
  //       zkfairStakeAbi
  //     ),
  //     Stake: new ethers.Contract(
  //       '0x97E3aB56ec2C13ACA2993076523F5b3D10D4A138',
  //       zkfairStakeAbi
  //     ),
  //     Token: new ethers.Contract(
  //       '0x427539B9f81cd890b554e4f3F36eBa6D6d96e61a',
  //       tokenAbi
  //     ),
  //     Game: new ethers.Contract(
  //       '0x60d078234bCDd1c86C5020D4a64A2213568765a4',
  //       mantaGameAbi
  //     ),
  //     Product: new ethers.Contract(
  //       '0x56345f409b17CE3943F521f9Ef9f0150435c43b4',
  //       katlaProductAbi
  //     ),
  //   },
  // },
  // {
  //   id: "167008",
  //   name: "Katla L2",
  //   nativeCurrency: { name: "ETH", symbol: "ETH", decimals: 18 },
  //   rpcUrls: ["https://rpc.katla.taiko.xyz"],
  //   tokenImg: "https://i.ibb.co/y5D8dJv/taiko.webp",
  //   blockExplorerUrls: "https://explorer.katla.taiko.xyz/",
  //   id: "167008",
  //   name: "Taiko Katla L2",
  //   nativeCurrency: { name: "ETH", symbol: "ETH", decimals: 18 },
  //   rpcUrls: ["https://rpc.katla.taiko.xyz"],
  //   tokenImg: "https://i.ibb.co/y5D8dJv/taiko.webp",
  //   blockExplorerUrls: "https://explorer.katla.taiko.xyz/",
  //   features: {
  //     spinValue: 0,
  //     mintValue: 0,
  //     stakeValue: 0,
  //     apiStaking: true,
  //     gasLimit: false,
  //   },
  //   contracts: {
  //     // Entrypass: new ethers.Contract(''),
  //     NFT: new ethers.Contract(
  //       "0xedd0dDaEdbc3FBf67aC4ff2ee14Ace669821eac1",
  //       katlaNFTAbi
  //     ),
  //     Stake: new ethers.Contract(
  //       "0x1670080000000000000000000000000000000003",
  //       []
  //     ),
  //     Token: new ethers.Contract(
  //       "0x14027051bB9fEDbb8D8559416b056C2CBf3aA238",
  //       tokenAbi
  //     ),
  //     Game: new ethers.Contract(
  //       "0x1A0ECe8a973Be50bd44842960D842dc35e3E83A4",
  //       katlaGameAbi
  //     ),
  //     Product: new ethers.Contract(
  //       "0xa3B919018c23f3F19A9CAb00C243245598666F87",
  //       katlaProductAbi
  //     ),
  //   },
  // },
  // {
  //   id: '1891',
  //   name: 'Pegasus Testnet',
  //   nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
  //   rpcUrls: ['https://replicator.pegasus.lightlink.io/rpc/v1'],
  //   tokenImg: 'https://i.ibb.co/7J0BZGf/lightlink-Logo.webp',
  //   blockExplorerUrls: 'https://pegasus.lightlink.io/',
  //   features: {
  //     spinValue: 5,
  //     mintValue: 10,
  //     stakeValue: 100,
  //     apiStaking: true,
  //     gasLimit: true,
  //   },
  //   // contracts: {
  //   //   NFT: new ethers.Contract(
  //   //     "0xLightLinkNFTContractAddress",
  //   //     stakeAbi // Replace with actual ABI for LightLink NFT
  //   //   ),
  //   //   Stake: new ethers.Contract(
  //   //     "0xLightLinkStakeContractAddress",
  //   //     stakeAbi // Replace with actual ABI for staking
  //   //   ),
  //   //   Token1: new ethers.Contract(
  //   //     "0xLightLinkToken1Address",
  //   //     tokenAbi // Replace with actual ABI for Token1
  //   //   ),
  //   //   Token2: new ethers.Contract(
  //   //     "0xLightLinkToken2Address",
  //   //     tokenAbi // Replace with actual ABI for Token2
  //   //   ),
  //   //   Game: new ethers.Contract(
  //   //     "0xLightLinkGameContractAddress",
  //   //     gameAbi // Replace with actual ABI for Game contract
  //   //   ),
  //   //   Product: new ethers.Contract(
  //   //     "0xLightLinkProductContractAddress",
  //   //     productAbi // Replace with actual ABI for Product contract
  //   //   ),
  //   // },
  // },
  // MORPH
  // {
  //   id: '2818',
  //   name: 'Morph',
  //   nativeCurrency: {
  //     name: 'ETH',
  //     symbol: 'ETH',
  //     decimals: 18,
  //   },
  //   rpcUrls: ['https://rpc-quicknode.morphl2.io'],
  //   blockExplorerUrls: ['https://explorer.morphl2.io/'],
  //   tokenImg: 'https://i.ibb.co/Rv1Sc7T/morph-Logo.webp',
  //   features: {
  //     gameValue: 0,
  //     mintValue: 0.00041,
  //     stakeValue: 0.00041,
  //     unStakeValue: 0,
  //     apiStaking: false,
  //     apiMinting: false,
  //   },
  //   contracts: {
  //     NFT: new ethers.Contract(
  //       '0x67d91eC3d43FC21CbB3c6fFcc490677D077E8DfC',
  //       stakeAbi
  //     ),
  //     Stake: new ethers.Contract(
  //       '0x67d91eC3d43FC21CbB3c6fFcc490677D077E8DfC',
  //       stakeAbi
  //     ),
  //     Token1: new ethers.Contract(
  //       '0x60d94ae2a429be78a1099733356Ab88009B049EF',
  //       tokenAbi
  //     ),
  //     Game: new ethers.Contract(
  //       '0x4dE7CD522f1715b2a48F3ad6612924841d450A0F',
  //       productGamesAbi
  //     ),
  //     Product: new ethers.Contract(
  //       '0xa75A5bEE03CC551999C193159f68b68768e16d7D',
  //       productAbi
  //     ),
  //   },
  // },

  // // BASE
  // {
  //   id: '8453',
  //   name: 'Base',
  //   nativeCurrency: {
  //     name: 'ETH',
  //     symbol: 'ETH',
  //     decimals: 18,
  //   },
  //   rpcUrls: ['https://rpc.ankr.com/base'],
  //   explorerUrl: ['https://basescan.org/'],
  //   tokenImg:
  //     'https://raw.githubusercontent.com/lifinance/types/main/src/assets/icons/chains/base.webp',
  //   features: {
  //     gameValue: 0.0052,
  //     mintValue: 0.002,
  //     stakeValue: 0.002,
  //     apiStaking: false,
  //     gasLimit: false,
  //     isMainnet: true,
  //   },
  //   contracts: {
  //     NFT: {
  //       address: '0xA01da2d3AbEFFbaa347B08C76EEC47169DdE72e9',
  //       abi: stakeAbi,
  //     },
  //     Stake: {
  //       address: '0xA68794F1F1D94F863473BDa21829Cd427b91eBeC',
  //       abi: productStakeAbi,
  //     },
  //     Token3: {
  //       address: '0x37BB310E970f7f8da8563191c7B4C1F0FDf5305a',
  //       abi: productTokenAbi,
  //     },
  //     Game: {
  //       address: '0xE6384ec1a6932707D43f5993D37242B1075a94fc',
  //       abi: productGamesAbi,
  //     },
  //     Product: {
  //       address: '0xE559051412d5244F61c7179FBe1D07DB46173BE5',
  //       abi: productAbi,
  //     },
  //     Deposit: {
  //       address: '0x3802276DD519ae9dAae011829bF9e8b95cd5D0fE',
  //       abi: gamesDeposit,
  //     },
  //   },
  // },
];

// Chain-specific color configurations
export const getChainColors = (chainId: number) => {
  const colorMap: Record<
    number,
    { primary: string; secondary: string; text: string; subColor: string }
  > = {
    59144: {
      // Linea
      primary: "#61DFFF",
      secondary: "#0082A3",
      text: "#61DFFF",
      subColor: "#61DFFF",
    },
    9030: {
      // Qubetics
      primary: "#000000",
      secondary: "#110036",
      text: "#FFFFFF",
      // subColor:'#281C62'
      subColor: "#44336A",
    },
    43114: {
      // Avalanche
      primary: "#E84142",
      secondary: "#FFFFFF",
      text: "#000000",
      subColor: "#E84142",
    },
    10143: {
      // Monad
      primary: "var(--color-primary)",
      secondary: "var(--color-secondary)",
      text: "var(--color-text)",
      subColor: "var(--color-subColor)",
    },
    43111: {
      // Hemi
      primary: "#ff6a00",
      secondary: "#1d2e34",
      text: "#FFFFFF",
      subColor: "#ff6a00",
    },
    1868: {
      // Hemi
      primary: "#5BF7FE",
      secondary: "#1d2e34",
      text: "#FFFFFF",
      subColor: "#5BF7FE",
    },
  };

  return (
    colorMap[chainId] || {
      primary: "var(--color-primary)", // Default Monad colors
      secondary: "var(--color-secondary)",
    }
  );
};
